import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CheckoutInfoPageRoutingModule } from './checkout-info-routing.module';

import { CheckoutInfoPage } from './checkout-info.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CheckoutInfoPageRoutingModule
  ],
  declarations: [CheckoutInfoPage]
})
export class CheckoutInfoPageModule {}
